module.exports = __webpack_public_path__ + "public/assets/img/reset-password-v2-dark.7f1fd154.svg";